(ns pfo.link.component
  (:require [reagent.core :as reagent :refer [atom]]
            [promesa.core :as p]
            [pfo.api :as api :refer [process-error]]
            [pfo.util :as util]
            [pfo.auth.model :as auth-model :refer [perm]]
            [pfo.link.model :as model]
            [clojure.string :refer [join]]
            [pfo.task.model :as task-model]
            [pfo.state :as state]
            [pfo.revroutes :refer [path-for]]))

(declare item-type-components link-add-chooser)

(def type-task "t")
(def type-task-occurrence "to")
(def type-event "e")
(def type-event-occurrence "eo")
(def type-document "d")
(def type-note "n")

(defn task-url [options item]
  (str "#/task/details/" (:id item) "/"))

(defn task-occurrence-url  [options item]
  (str "#/task/details/" (:task_id item) "/" (util/date-string (:complete_by item)) "/"))

(defn event-url  [options item]
  (str "#/event/details/id/" (:id item) "/"))

(defn event-occurrence-url  [options item]
  (str "#/event/details/" (:key item) "/"))

(defn document-url  [options item]
  (str "#/document/details/" (:id item)))

(defn note-url  [options item]
  (str "#/document/details/" (:id item)))

(def item-type-urls
  {type-task task-url
   type-task-occurrence task-occurrence-url
   type-event event-url
   type-event-occurrence event-occurrence-url
   type-document document-url
   type-note note-url})

(defn item-url [options item]
  ((item-type-urls (:object_type item)) options item))

(defn parent-info-url [parent-info]
  (item-url nil {:object_type (:parent-type parent-info)
                 :id (:parent-id parent-info)
                 :task_id (:parent-id parent-info)
                 :key (:key parent-info)
                 :complete_by (:complete-by parent-info)}))


(defn list-item [options item]
  [(item-type-components (:object_type item)) options item])

(defn link-map-entry [options items]
  {:options options :items items})

(defn linked-items [options linked-structured-items]
  (let [visible-count 5
        show-more? (atom false)]
    (fn [options linked-structured-items]
      (let [items-with-options (for [{:keys [options items]} linked-structured-items
                                     item items]
                                 {:item item :options options})
            displayed-items (if @show-more?
                              items-with-options
                              (take visible-count items-with-options))]
        [:div
         [:ul.c-linked-items
          (doall
           (for [structured-item displayed-items]
             (let [item (:item structured-item)
                   options (:options structured-item)]
               [:div.c-linked-items__item-wrapper {:key (:id item)}
                [:button.c-round-button.c-linked-items__delete-button
                 {:on-click (util/handler
                             (fn []
                               (when (.confirm js/window "Are you sure you want to remove the link to this object?")
                                 (->> (model/delete-link
                                       (:parent-type options)
                                       (:parent-id options)
                                       (:object_type item)
                                       (:id item))
                                      (p/map (fn [_] ((:reload options))))
                                      (process-error)))))
                  :disabled (:disabled options)}
                 "×"]

                [:div (when (= (:items-type options) "parent") {:class "c-parent-linked-item"})
                 [:li.o-margin-elements--medium
                  [:span.c-linked-items__item
                   {:class (util/classes
                            (:object_type item)
                            (when (or (get-in item [:group :compliance])
                                      (get-in item [:task :group :compliance]))
                              :compliance))}
                   [list-item options item]]
                  [:a.c-linked-items__newtab-button
                   {:target "_blank"
                    :href (item-url options item)}
                   [:img {:src "/static/img/icons/newtab.png"}]]]]])))]

         (when (> (count items-with-options) visible-count)
           [:div.u-margin-bottom
            [:a.u-color--secondary {:on-click #(swap! show-more? not)}
             (if @show-more? "...less" "more...")]])]))))

(defn task-name [{{multi-step :multi_step
                   group-name :name}
                  :group
                  :as task}]
  (if (and multi-step (not-empty group-name))
    group-name
    (task-model/task-name task)))

(defn occurrence-name [{{multi-step :multi_step
                         group-name :name}
                        :group
                        :as occurrence}]
  (if (and multi-step (not-empty group-name))
    group-name
    (task-model/task-name (if (:complete occurrence) occurrence (:task occurrence)))))

(defn task-item [options item]
  [:a.link
   (merge {:href (task-url options item)} (:anchor-attrs options))
   (if (:reccurring item) "" (str (util/date-reformat (:default_date item)) ": "))  (task-name item)])

(defn task-occurrence-item  [options item]
  [:a.link
   (merge {:href (task-occurrence-url options item)} (:anchor-attrs options))
   (util/date-reformat (:complete_by item))
   ": "
   (occurrence-name item)])

(defn event-item  [options item]
  [:a.link
   {:href (event-url options item)}
   (if (:reccurring item) "" (str (util/date-reformat (:default_date item)) ": "))   (:name item)])

(defn event-occurrence-item  [options item]
  [:a.link
   (merge {:href (event-occurrence-url options item)}  (:anchor-attrs options))
   (util/date-reformat (:complete_by item)) ": " (:name item)])

(defn document-item  [options item]
  [:a.link
   (merge {:href (document-url options item)}  (:anchor-attrs options))
   (let [collection-name (if-let [main-collection-name (:main_collection_name item)]
                           main-collection-name
                           (get-in item [:document_collections 0 :collection :name]))]
     (when collection-name
       [:span collection-name " » "]))
   (:complex_name item)])

(defn note-item  [options item]
  [:a.link
   (merge {:href (note-url options item)}  (:anchor-attrs options))
   (let [collection-name (if-let [main-collection-name (not-empty (:main_collection_name item))]
                           main-collection-name
                           (get-in item [:document_collections 0 :collection :name]))]
     (when collection-name
       [:span collection-name " » "]))
   (:complex_name item)])

(def item-type-components
  {type-task task-item
   type-task-occurrence task-occurrence-item
   type-event event-item
   type-event-occurrence event-occurrence-item
   type-document document-item
   type-note note-item})

(defn link-add-chooser [options]
  (let [show-menu (atom false)
        set-linked-location (fn [object-type params e]
                              (util/set-location
                               (path-for object-type :query-params params))
                              (.stopPropagation e))]

    (reagent/create-class 
     {:display-name "link-add-chooser"
      
      :reagent-render (fn [options]
                        (let [exclude (:exclude-types options)
                              params  (util/make-params (util/remove-nil-values
                                                         {:collection_id (:initial-collection-id options)
                                                          :parent_collection_ids (join "," (:parent-collection-ids options))
                                                          :parent_type (get-in options [:parent :type])
                                                          :parent_id (get-in options [:parent :id])
                                                          :complete_by (get-in options [:parent :complete-by])
                                                          :parent_key (get-in options [:parent :key])}))]
                          
                          
                          [:label.link-items-controls
                           (perm :can_add_document (when-not (contains? exclude "d")
                                                     [:span.link-item
                                                      [:img
                                                       {:src "/static/img/icons/document-add.svg"
                                                        :title "Add Document"
                                                        :on-click #(set-linked-location :document-add-or-choose params %1)}]]))
                           (perm :can_add_task (when-not (contains? exclude "t")
                                                 [:span.link-item.task
                                                  [:img
                                                   {:src "/static/img/icons/task-add.svg"
                                                    :title "Add Task"
                                                    :on-click #(set-linked-location :task-add-or-choose params %1)}]]))
                           
                           (perm :can_add_event (when-not (contains? exclude "e")
                                                  [:span.link-item
                                                   [:img
                                                    {:src "/static/img/icons/event-add.svg"
                                                     :title "Add Event"
                                                     :on-click #(set-linked-location :event-add params %1)}]]))
                           (:linked-items-documents-download options)]))})))

(defn linked-items-documents-download-form [key]
  (fn [key]
    (let [form-ref (atom nil)]
      (when key
        [:span.link-item
         [:form
          {:ref (fn [node] (reset! form-ref node))
           :method :post
           :action (str "/download/linked/documents/")}
          [:input
           {:type  :hidden
            :name  :key
            :value key}]
           [:img {:src "/static/img/icons/file-download.svg"
                  :title "Download Documents"
                  :on-click (fn [_] (.submit @form-ref))}]]]))))

(defn linked-items-counter [linked-items task-links format]
  (let [linked-items-count (+ (-> linked-items :parents count)
                              (-> linked-items :children count)
                              (-> task-links :parents count))
        task-id (:id task-links)]
    (if format
      (when (> linked-items-count 0)
        (str "(" linked-items-count ")"))
      linked-items-count)))



